import React, { Fragment, useState } from "react";
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";

const ContactUs = () => {

    const [data, setData] = useState({
        email:"",
        name:"",
        phone:"",
        subject:"",
        comments:""
    })

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setData({
            ...data,
            [evt.target.id]: value
        })
    }

    // Sanitize input to prevent XSS - strips HTML tags and dangerous patterns
    const sanitizeInput = (str) => {
        if (!str) return '';
        return str
            .replace(/<[^>]*>/g, '')           // Remove HTML tags
            .replace(/javascript:/gi, '')       // Remove javascript: protocol
            .replace(/on\w+=/gi, '')            // Remove event handlers like onclick=
            .replace(/[<>]/g, '')               // Remove any remaining < > characters
            .trim();
    }

    // Handle blur event for text fields - sanitize input
    const onTextBlur = (evt) => {
        const fieldId = evt.target.id;
        const sanitizedValue = sanitizeInput(data[fieldId]);
        setData({
            ...data,
            [fieldId]: sanitizedValue
        })
    }
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [showResponse, setShowResponse] = useState(false)

    const api = RestHelperNoAuth()

    const clearForm = () => {
        setShowResponse(false)
        setShowForm(true)
        setData({
            ...data,
            ['email']: '',
            ['name'] : '',
            ['phone'] : '',
            ['subject'] : '',
            ['comments'] : ''
        })
    }

    const setApiRes = (res) => {
        setShowResponse(true)
        setIsLoading(false)
        setApiDetails(res['details'])
        setApiMessage(res)
    }

    const callApi = () => {
        const options = {}
        setIsLoading(true)
        setShowForm(false)
        api
        .postCreate('/create-contact-request', options, data)
        .then(res => setApiRes(res))
        .catch(err => console.log(err))
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        callApi()
    }

    return (
        <div className="max-w-2xl mx-auto px-4 py-8">
            {showResponse && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                    <div className="px-6 py-4 border-b border-neutral-200 flex items-start justify-between">
                        <div>
                            <h2 className="text-lg font-semibold text-green-700">Message Sent</h2>
                            <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                        </div>
                        <button
                            className="text-neutral-400 hover:text-neutral-600 text-2xl font-light"
                            aria-label="Close"
                            onClick={clearForm}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="p-6">
                        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                            <p className="text-green-800 font-medium">{apiMessage}</p>
                            {apiDetails && <p className="text-green-700 mt-2">{apiDetails}</p>}
                        </div>
                        <button
                            onClick={clearForm}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                        >
                            Send Another Message
                        </button>
                    </div>
                </div>
            )}

            {showForm && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                    <div className="px-6 py-4 border-b border-neutral-200">
                        <h2 className="text-lg font-semibold text-neutral-800">Contact Us</h2>
                        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                    </div>
                    <div className="p-6">
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                            <p className="text-neutral-700">
                                Thanks for your interest in contacting us! Please fill out the fields below and let us know how we can help you.
                            </p>
                            <p className="text-neutral-700 mt-2">
                                Or feel free to give us a call at <a href="tel:888-530-7592" className="font-semibold text-blue-600 hover:underline">(888) 530-7592</a>.
                            </p>
                            <p className="text-neutral-600 text-sm mt-2">
                                All feedback is appreciated and we'll be in touch soon!
                            </p>
                        </div>

                        <form onSubmit={onSubmitHandler}>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label htmlFor="name" className="block text-sm font-medium text-neutral-700 mb-1">Name</label>
                                    <input
                                        className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        id="name"
                                        onChange={(e) => onChangeEvent(e)}
                                        onBlur={(e) => onTextBlur(e)}
                                        type="text"
                                        value={data.name}
                                        placeholder="Your name"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">Email</label>
                                    <input
                                        className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        id="email"
                                        onChange={(e) => onChangeEvent(e)}
                                        onBlur={(e) => onTextBlur(e)}
                                        type="email"
                                        value={data.email}
                                        placeholder="you@example.com"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label htmlFor="phone" className="block text-sm font-medium text-neutral-700 mb-1">Phone Number</label>
                                    <input
                                        className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        id="phone"
                                        onChange={(e) => onChangeEvent(e)}
                                        onBlur={(e) => onTextBlur(e)}
                                        type="tel"
                                        value={data.phone}
                                        placeholder="(555) 123-4567"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="subject" className="block text-sm font-medium text-neutral-700 mb-1">Subject <span className="text-red-500">*</span></label>
                                    <input
                                        className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                        id="subject"
                                        onChange={(e) => onChangeEvent(e)}
                                        onBlur={(e) => onTextBlur(e)}
                                        type="text"
                                        value={data.subject}
                                        placeholder="How can we help?"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="mb-6">
                                <label htmlFor="comments" className="block text-sm font-medium text-neutral-700 mb-1">Comments / Feedback / Report an Issue <span className="text-red-500">*</span></label>
                                <textarea
                                    className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors min-h-[120px]"
                                    id="comments"
                                    onChange={(e) => onChangeEvent(e)}
                                    onBlur={(e) => onTextBlur(e)}
                                    value={data.comments}
                                    placeholder="Tell us more..."
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {isLoading && (
                <div className="flex flex-col items-center justify-center py-12">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                    <p className="text-neutral-600">Sending your message...</p>
                </div>
            )}
        </div>
    )
};

export default ContactUs;